// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2Nkne","range":"MonthRangeSwitch_range__3dRvo","disabled":"MonthRangeSwitch_disabled__SEGe3"};